import { __ } from "@wordpress/i18n";
import { useBlockProps, RichText, InnerBlocks } from "@wordpress/block-editor";

import { useState } from "@wordpress/element";

import Settings from "./Settings";
const TEMPLATE = [
  [
    "core/group",
    {
      style: {
        spacing: {
          padding: {
            top: "20px",
            bottom: "20px",
          },
          margin: {
            top: "20px",
          },
        },
        border: {
          top: {
            style: "solid",
            width: "1px",
            color: "#E8EFF7",
          },
        },
      },
    },
    [
      [
        "core/paragraph",
        {
          content: __("Collapsible content...", "brandy-blocks"),
          placeholder: __("Add content for collapsible...", "brandy-blocks"),
        },
      ],
    ],
  ],
];

export default function Edit({ attributes, setAttributes }) {
  const { header, iconOpen, iconClose, style } = attributes;

  const {
    headerActiveColor,
    activeBackground,
    headerActiveTypography,
    activeBorder,
    activeShadow,
  } = style;

  const [isOpen, setIsOpen] = useState(true);

  const blockProps = useBlockProps({
    className:
      (activeBackground?.slug !== ""
        ? `has-${activeBackground?.slug}-active-background-color`
        : activeBackground?.color !== ""
        ? "has-active-background-color"
        : "") +
      " " +
      (headerActiveColor?.slug !== ""
        ? `has-${headerActiveColor?.slug}-header-active-color`
        : headerActiveColor?.color !== ""
        ? "has-header-active-color"
        : ""),
    style: {
      "--header-active-color":
        headerActiveColor?.slug !== ""
          ? `var(--wp--preset--color--${headerActiveColor?.slug})`
          : headerActiveColor?.color,
      "--header-active-font-size": headerActiveTypography?.fontSize,
      "--header-active-font-weight": headerActiveTypography?.fontWeight,
      "--header-active-text-transform": headerActiveTypography?.textTransform,
      "--active-border-style": activeBorder?.style,
      "--active-border-width": activeBorder?.width,
      "--active-border-color": activeBorder?.color,
      "--active-shadow": activeShadow,
      "--active-background":
        activeBackground?.slug !== ""
          ? `var(--wp--preset--color--${activeBackground?.slug})`
          : activeBackground?.color,
    },
  });

  return (
    <>
      <Settings attributes={attributes} setAttributes={setAttributes} />
      <details
        {...blockProps}
        open={isOpen}
        data-icon-open={iconOpen}
        data-icon-close={iconClose}
      >
        <summary
          onClick={() => setIsOpen(!isOpen)}
          data-header-active-typography={JSON.stringify(headerActiveTypography)}
        >
          <RichText
            tagName="span"
            value={header}
            onChange={(newHeader) => setAttributes({ header: newHeader })}
            placeholder={__("Enter header text...", "brandy-blocks")}
          />
          <span className="collapsible-icon open-icon">
            <i className={`ph ph-${iconOpen}`}></i>
          </span>
          <span className="collapsible-icon close-icon">
            <i className={`ph ph-${iconClose}`}></i>
          </span>
        </summary>
        <div className="collapsible-content">
          <InnerBlocks
            template={TEMPLATE}
            templateLock={false}
            renderAppender={InnerBlocks.ButtonBlockAppender}
          />
        </div>
      </details>
    </>
  );
}
